import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { HeaderLayout } from '../../../components/Header/Redesign';
import { useEventBus } from '../../../hooks/useEventBus';
import { IApplicationState } from '../../../types/redux';
import { AuthenticationModalContainer } from '../../AuthenticationModalContainer';
import { DropdownContainer } from '../../DropdownContainer';
import { DropdownBackdropContainer } from '../../DropdownContainer/DropdownBackdropContainer';
import { HamburgerContainer } from '../../HamburgerContainer';
import { LogoContainer } from '../../LogoContainer';
import { MenuContainer } from '../../MenuContainer/MenuContainer';
import { NavBarContainer } from '../../NavBarContainer/Redesign';
import { UserRelatedContainer } from '../../UserRelatedContainer';

export const HeaderContainer: React.FC = () => {
  useEventBus();

  const noResize = useSelector((state: IApplicationState) => state.noResize);
  const buttonRef = React.useRef<HTMLButtonElement | null>(null);
  const navbarRef = React.useRef<HTMLDivElement | null>(null);

  if (noResize) {
    return (
      <>
        <HeaderLayout
          noResize={noResize}
          content={
            <>
              <LogoContainer />
              <Responsive desktop>
                <MenuContainer menuRef={buttonRef} />
              </Responsive>
              <UserRelatedContainer />
              <AuthenticationModalContainer />
            </>
          }
          navbar={<NavBarContainer navbarRef={navbarRef} />}
        >
          <DropdownContainer menuRef={buttonRef} navbarRef={navbarRef} />
        </HeaderLayout>
        <DropdownBackdropContainer />
      </>
    );
  }

  return (
    <>
      <HeaderLayout
        noResize={noResize}
        content={
          <>
            <Responsive phone tablet>
              <HamburgerContainer />
            </Responsive>
            <LogoContainer />
            <Responsive desktop>
              <MenuContainer menuRef={buttonRef} />
            </Responsive>
            <UserRelatedContainer />
            <AuthenticationModalContainer />
          </>
        }
        navbar={
          <Responsive desktop>
            <NavBarContainer navbarRef={navbarRef} />
          </Responsive>
        }
      >
        <DropdownContainer menuRef={buttonRef} navbarRef={navbarRef} />
      </HeaderLayout>
      <DropdownBackdropContainer />
    </>
  );
};
